export interface Resource {
  id: number | string;
  name: string;
}

export interface Supplier {
  id: number | string;
  name: string;
}

export interface Client {
  id: number | string;
  name: string;
}

export interface Seller {
  id: number | string;
  name: string;
}

export interface ApiItems {
  id: number | string;
  name: string;
  density?: number;
  ncm?: string;
  totalWeight?: number;
  costPerKg?: number;
}

export interface MaterialItem {
  materialId: number;
}

export interface ProductItem {
  productId: number;
}

export interface ServiceItem {
  serviceType?: string;
}

export interface ResourceItem {
  resourceId: number;
}

export enum OrderItemType {
  SERVICE = "SERVICE",
  MATERIAL = "MATERIAL",
  PRODUCT = "PRODUCT",
  RESOURCE = "RESOURCE",
}